
// src/pages/Dashboard/ContactPersonBalance/index.jsx
import React from 'react';
import styles from './index.module.css';
import ContactPersonBalanceTable from './components/ContactPersonBalanceTable';

const ContactPersonBalance = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.header}>
          <h1 className={styles.title}>Customer Balance</h1>
          {/* Add search bar here if needed */}
        </div>
        
        <ContactPersonBalanceTable />
      </div>
    </div>
  );
};

export default ContactPersonBalance;